<template>

<div class="group" v-if="count">

	<com-text v-if="item.text" :item="item" />

	<div class="group-inputs" :class="{'is-slim': !theme.form.group.bullets}">

		<com-input v-for="input in item.inputs" :key="input" :input="inputs[input]" />

	</div>
	
	<com-info v-if="item.info" :info="item.info" />

</div>

</template>

<script>

import comInput from './Input'
import comText from './Text'
import comInfo from './Info'

export default {

	props: ['item'],

	components: {
		'com-input': comInput,
		'com-text': comText,
		'com-info': comInfo
	},

	computed: {

		count: function() {

			var count = 0

			this.$_.each(this.item.inputs, function(id) {

				if (this.visible(this.inputs[id])) {

					count++

				}

			}.bind(this))

			return count

		}

	}

}

</script>

<style scoped>

.group-inputs:not(.is-slim) {
	padding-left: 32px;
}

.is-mobile .group-inputs:not(.is-slim) {
	padding-left: 0px;
}

.group-inputs:not(.is-slim) >>> .input:after {
	content: ' ';
	position: absolute;
	width: 8px;
	height: 8px;
	border-radius: 4px;
	background-color: var(--primary-color);
	top: 20px;
	left: -32px;
	z-index: 3;
}

.is-mobile .group-inputs:not(.is-slim) >>> .input:after {
	left: -19px;
	top: 5px;
}

.group-inputs:not(.is-slim) >>> .input:before {
	content: ' ';
	position: absolute;
	left: -29px;
	bottom: 50%;
	height: 100px;
	width: 2px;
	background-color: #f6f6f6;
	z-index: 1;
}

.is-mobile .group-inputs:not(.is-slim) >>> .input:before {
	left: -16px;
	bottom: calc(100% - 5px);
	height: 200px;
}

.group-inputs:not(.is-slim) >>> .input:first-child:before {
	background-color: #fff;
	z-index: 2;
	height: 56px;
}

.is-mobile .group-inputs:not(.is-slim) >>> .input:first-child:before {
	height: 200px;
}

</style>